export default __webpack_public_path__ + "static/media/GRAD.9543e883.jpg";